import React, { Component } from 'react'
import { checkTranslation, chooseWallpaper, conditionalWidth, translate } from "../../utils/useful";
import Responsive from '../../components/Responsive';
import ButtonAnimated from '../../components/buttons/ButtonAnimated';
import CAHeader from '../../components/header/CAHeader';
import { bindActionCreators } from 'redux';
import { connect } from 'react-redux';
import * as actions from '../../stores/actionsList';
import SubscriptionPage from '../Applets/SubscriptionPage';
// import CustomLoader from '../../components/CustomLoader';
// import { nanoid } from 'nanoid';

class CHPricing extends Component {

    state = {
        display: true,

    }

    componentDidMount() {
        if (this.props.setHeader) {

            this.props.setHeader({

                'toolbar': null,
                'showToolbar': false,
                isPortal: true,
                doNotshowNotification: true,
                showSettings: false,
                'title': '{{lang}}Create Hub | Pricing',
                create: true,
                topHeaderComponent: this.topHeaderComponent,
                backAction: () => this.props.lastStage()

            })
        }
    }

    setHeader = (key, value) => {
        if (this.header) {
            if (typeof key == 'object') {
                let object = {
                    showSettings: true,
                    showFrames: 'static'
                }
                if (this.props.defaultHeaderConfig) {
                    object = { ...this.props.defaultHeaderConfig }
                }
                for (const [okey, ovalue] of Object.entries(key)) {
                    object[okey] = ovalue
                }
                if (object.showSettings && this.props.showSettings) {
                    object.showSettings = this.props.showSettings
                }
                this.setState({ headerConfig: object }, () => {
                    this.header.forceUpdate()
                })
            }
            else {
                this.setState({ headerConfig: { ...this.state.headerConfig, [key]: value } }, () => {
                    this.header.forceUpdate()
                })
            }
        }
    }

    topHeaderComponent = () => {
        return (
            <div className='flexc'>
                {/* <ButtonAnimated
                    iconwidth='24px'
                    onClick={this.nextClicked}
                    isLoading={this.state.isLoading}
                    title={translate("Next Step")}
                    icon='/assets/icons/angle-right-white2.svg'
                    textColor={'#222'}
                    invert={!this.props.colors?.iconInvert}
                    bg={this.props.colors?.iconInvert ? '#000' : '#fff'}
                /> */}
            </div>
        )
    }

    nextClicked = (status, serviceType) => {
        let data = this.props.initData
        if (status == 0) {
            if (this.props.initData?.category) {
                this.props.changeStage("info")
            }
        }
        else {
            this.props.setStatus(2, () => {
                data.serviceType = serviceType
                this.props.setData(data, () => {
                    this.props.changeStage("pricingInfo")
                })
            })
        }
        // else {
        //     this.props.actions.addNotif({ type: 'error', title: '{{lang}}errors.ContentEmpty' })
        // }
    }

    changeType = (prop, index) => {
        this.props.setData({ category: prop.name }, () => {
        })
    }

    toggleDisplay = () => {
        this.setState(prevState => ({
            display: !prevState.display
        }))
    }

    afterSet = (item) => {
        this.props.setCardItem(item, () => {
            this.props.changeStage("review")
        })
    }

    render() {
        return (
            <div className=" w-100 h-100 scroll-no-scrollbar position-relative window-content-radius" style={{}}>
                {/* <div className='w-100' style={{ position: 'sticky', top: 0 }}>
                    <CAHeader ref={el => this.header = el} config={this.state.headerConfig} toolbar={this.state.toolbar} showToolbar={this.state.showToolbar} type={'static'} functionsHandler={this.functionsHandler} page={this.state.page} language={this.props.language} toolbarView={'applet'} headertype={'applet'} headers={this.state.headers} goToHub={this.props.goToHub} backStage={this.backStage} sections={this.state.sections} modules={this.state.modules} changePage={this.changePage} backbtn={this.state.showBackBtn} applet={this.props.applet} width={this.props.width} colors={this.props.colors} features={this.props.applet?.features} />
                </div> */}
                <div className=' w-100 flexc flex-column '  >
                    <SubscriptionPage width={this.props.width} variables={this.props.variables} windowData={this.props.windowData} colors={this.props.colors} changePage={this.changePage} baseUrl={[...this.props.baseUrl]} setHeader={this.setHeader} applet={this.props.applet} pages={this.state.pages} height={this.props.height} setData={this.props.setData} changeStage={this.props.changeStage} initData={this.props.initData} afterSet={this.afterSet}/>

                </div>
            </div>
        )
    }
}

const mapStateToProps = state => ({ settings: state.settings, user: state.user, connections: state.connections })
const mapDispatchToProps = dispatch => ({ actions: bindActionCreators(actions, dispatch) })

export default connect(
    mapStateToProps,
    mapDispatchToProps
)(CHPricing);
// export default CHPricing;